import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/api';

export const useMeta = () => useQuery({ queryKey: ['meta'], queryFn: api.meta, staleTime: 5 * 60_000 });

export const useShortlists = (enabled = true) =>
  useQuery({ queryKey: ['shortlists'], queryFn: api.shortlists, enabled });

/** Capabilities with safe defaults while meta is loading / failed. */
export function useCapabilities() {
  const { data, isLoading } = useMeta();
  const caps = data?.capabilities || {};
  return { semantic: !!caps.semantic, visual: !!caps.visual, ai: !!caps.ai, loading: isLoading };
}
